module.exports = __webpack_public_path__ + "static/media/ae.d702c4f8.svg";